<project-data [idProject]="idProject" [loadOnInit]="true" [uiSettings]="uiSettings"  [includeMetadata]="0"></project-data>
<p-confirmDialog [baseZIndex]="10100"></p-confirmDialog>
